<template>
  <a @click="checkModal();" class="kp-button kp-button__min btn-gray">
    <span class="kp-panel-down" aria-hidden="true"></span>
    {{ $t('general.actions.export').toUpperCase() }} {{ $t('general.labels.table').toUpperCase() }}
  </a>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    list: 'reportList',
    reportExportLimit: 'reportExportLimit',
  }),
  methods: {
    ...mapActions([
      'modalOpen',
    ]),
    checkModal() {
      const numberOfSubmissions = this.list.quantity_of_submissions;
      let targetModal = 'export-table';

      if (numberOfSubmissions > this.reportExportLimit) {
        targetModal = 'cant-export';
      }

      this.modalOpen(targetModal);
    },
  },
};
</script>




/** WEBPACK FOOTER **
 ** ExportButton.vue?350210fd
 **/